<mat-dialog-content class="zip-search">
	<button
		mat-dialog-close
		class="o-modal-dismiss"
	>
		<epi-icon
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
	>
		Zip Code
	</epi-heading>
	<p class="zip-search__copy u-margin-top-small">
		Enter the Zip Code where your vet clinic is located.
	</p>
	<epi-input
		input-id="vetSearchZip"
		class="zip-search__input-wrapper u-margin-top-small"
	>
		<span slot="label">Zip Code</span>
		<input
			[formControl]="vetClinicZip"
			type="text"
			inputmode="numeric"
			slot="epiInput"
			minlength="5"
			maxlength="5"
		>
	</epi-input>
	<section class="zip-search__actions u-margin-top-medium">
		<epi-button
			[disabled]="vetClinicZip.invalid"
			(click)="updateZipCode()"
		>Update Zip Code</epi-button>
		<epi-button
			mat-dialog-close
			button-type="minimal"
			color="secondary"
		>Cancel</epi-button>
	</section>
</mat-dialog-content>